document.addEventListener('DOMContentLoaded', () => {
  // Grab all media items
  const mediaItems = document.querySelectorAll('li[ref="media[]"]');

  // Grab the variant input
  const variantInput = document.querySelector('input[ref="variantId"]');

  function updateMediaGallery(variantId) {
    console.log(variantId)
    mediaItems.forEach(item => {
      const variantIds = item.dataset.variantId?.split(',') || [];
      if (variantIds.includes(variantId)) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }

  // Initial load
  if (variantInput) {
    updateMediaGallery(variantInput.value);
  }

  // Observe changes to the input's value
  const observer = new MutationObserver(() => {
    updateMediaGallery(variantInput.value);
  });

  observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
});